import { getDefaultMargin, getDefaultMarginOverlay, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const ShoppingCartDesignSettings = {
  // dimension
  'shopping-cart-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'shopping-cart-design-image-width': {
    phone: ['80px'],
    'phone-landscape': ['80px'],
    tablet: ['80px'],
    'tablet-landscape': ['80px'],
    desktop: ['80px'],
    tv: ['80px'],
  },

  // alignment
  'shopping-cart-design-comp-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'shopping-cart-design-comp-title-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },

  // spacing
  'shopping-cart-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'shopping-cart-design-comp-title-margin': {
    phone: getDefaultMargin([10, 0]),
    'phone-landscape': getDefaultMargin([10, 0]),
    tablet: getDefaultMargin([10, 0]),
    'tablet-landscape': getDefaultMargin([10, 0]),
    desktop: getDefaultMargin([10, 0]),
    tv: getDefaultMargin([10, 0]),
  },

  // (nested) typography
  'shopping-cart-design-typography': {
    'shopping-cart-design-comp-title-typography': {
      phone: getDefaultTypography('headline-extra-small'),
      'phone-landscape': getDefaultTypography('headline-extra-small'),
      tablet: getDefaultTypography('headline-extra-small'),
      'tablet-landscape': getDefaultTypography('headline-extra-small'),
      desktop: getDefaultTypography('headline-extra-small'),
      tv: getDefaultTypography('headline-extra-small'),
    },
    'shopping-cart-design-title-typography': {
      phone: getDefaultTypography('body-medium'),
      'phone-landscape': getDefaultTypography('body-medium'),
      tablet: getDefaultTypography('body-medium'),
      'tablet-landscape': getDefaultTypography('body-medium'),
      desktop: getDefaultTypography('body-medium'),
      tv: getDefaultTypography('body-medium'),
    },
    'shopping-cart-design-info-typography': {
      phone: getDefaultTypography('body-extra-small'),
      'phone-landscape': getDefaultTypography('body-extra-small'),
      tablet: getDefaultTypography('body-extra-small'),
      'tablet-landscape': getDefaultTypography('body-extra-small'),
      desktop: getDefaultTypography('body-extra-small'),
      tv: getDefaultTypography('body-extra-small'),
    },
  },
}
